import type { GetInvoiceResponse } from '@vy/api-definition';
import { GetInvoiceResponseSchema } from '@vy/api-definition';
import { validateNotEmptyObject } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useInvoice(invoiceId: string, options?: CustomUseQueryOptions<GetInvoiceResponse>) {
  const invoiceQuery = useQuery(
    queryKeys.invoice(invoiceId),
    async () => {
      const api = getPrivateApi();
      const getInvoiceResponse = await api.getInvoice({ invoiceId });

      return GetInvoiceResponseSchema.parse(getInvoiceResponse);
    },
    { suspense: true, ...options },
  );

  validateNotEmptyObject(invoiceQuery.data, `Invoice with id ${invoiceId}`);

  return invoiceQuery;
}
